import React from 'react';

const Req = () => <span style={{ color: '#e53e3e', marginLeft: '3px', fontWeight: '700' }}>*</span>;

const TestimonialModal = ({ editItem, onSave, onClose }) => {
    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3>{editItem ? 'Edit Testimonial' : 'Add Testimonial'}</h3>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <form onSubmit={onSave} className="admin-modal-body">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        <div>
                            <label className="admin-label">Client Name<Req /></label>
                            <input type="text" name="name" defaultValue={editItem?.name || ''} className="admin-input" required />
                        </div>
                        <div>
                            <label className="admin-label">Rating Stars (1-5)<Req /></label>
                            <input type="number" min="1" max="5" name="rating" defaultValue={editItem?.rating || 5} className="admin-input" required />
                        </div>
                    </div>
                    <div className="m-t15">
                        <label className="admin-label">Testimonial Review Quote<Req /></label>
                        <textarea name="quote" defaultValue={editItem?.quote || ''} className="admin-textarea" rows="4" required />
                    </div>

                    <div className="admin-modal-footer m-t20">
                        <button type="button" className="admin-btn admin-btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="admin-btn admin-btn-primary">Save Testimonial</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TestimonialModal;
